import cn from 'classnames';
import * as React from 'react';
import { useEffect, useRef } from 'react';
import theme from './CommentNumber.module.scss';
export var CommentNumber = React.memo(function (_a) {
    var isSmall = _a.isSmall, isPositioned = _a.isPositioned, isInteractive = _a.isInteractive, isDragged = _a.isDragged, isReadOnly = _a.isReadOnly, num = _a.number, onClick = _a.onClick, style = _a.style, className = _a.className, isActive = _a.isActive;
    var ref = useRef(null);
    useEffect(function () {
        var _a;
        if (isActive) {
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
    }, [isActive]);
    return (React.createElement("div", { ref: ref, className: cn(theme.commentNumber, isSmall && theme.commentNumber_sm, isReadOnly && theme.commentNumber_readonly, isPositioned && theme.commentNumber_positioned, isInteractive && theme.commentNumber_interactive, isDragged && theme.commentNumber_drag, className), style: style, onClick: onClick }, num));
});
//# sourceMappingURL=CommentNumber.js.map